module.exports = __webpack_public_path__ + "static/media/main idea.3fd6f49b.mp3";